import builder from '../builder';
import MapsPin1 from '../../streamline-icons/light/maps-pin-1.svg';

export default builder('IconMapsPin1Light', MapsPin1);
